import * as betgalaxy from './Toggle.styles.betgalaxy';
import * as betprofessor from './Toggle.styles.betprofessor';
import * as betroyale from './Toggle.styles.betroyale';
import * as fiestabet from './Toggle.styles.fiestabet';
import * as goldenrush from './Toggle.styles.goldenrush';
import * as juicybet from './Toggle.styles.juicybet';
import * as puntcity from './Toggle.styles.puntcity';
import * as puntgenie from './Toggle.styles.puntgenie';
import * as questbet from './Toggle.styles.questbet';
import * as sterlingparker from './Toggle.styles.sterlingparker';
import * as vikingbet from './Toggle.styles.vikingbet';
import * as volcanobet from './Toggle.styles.volcanobet';
import * as wellbet from './Toggle.styles.wellbet';
import * as forsport from './Toggle.styles.forsport';
import * as junglebet from './Toggle.styles.junglebet';
import * as betstride from './Toggle.styles.betstride';
import * as oldgill from './Toggle.styles.oldgill';
import * as sugarcastle from './Toggle.styles.sugarcastle';
import * as buffalobet from './Toggle.styles.buffalobet';
import * as titanbet from './Toggle.styles.titanbet';
import * as gigabet from './Toggle.styles.gigabet';
import * as slambet from './Toggle.styles.slambet';
import * as templebet from './Toggle.styles.templebet';
import * as goldenbet888 from './Toggle.styles.goldenbet888';
import * as hyperbet from './Toggle.styles.hyperbet';
import * as chromabet from './Toggle.styles.chromabet';
import * as bet575 from './Toggle.styles.bet575';
import * as epicodds from './Toggle.styles.epicodds';
import * as magnumbet from './Toggle.styles.magnumbet';
import * as pyramidbet from './Toggle.styles.pyramidbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  chromabet,
  bet575,
  epicodds,
  magnumbet,
  pyramidbet,
};
